/**
 * Parses Google Place address components into the app address shape.
 * Prefers `locality` for city and falls back to `sublocality_level_1`.
 */
export default function parseGoogleAddress(addressComponents) {
  const componentsByType = {};

  const getLongName = (component) => component?.long_name || component?.longText || '';
  const getShortName = (component) => component?.short_name || component?.shortText || getLongName(component);

  addressComponents.forEach((component) => {
    for (const type of component.types) {
      if (!componentsByType[type]) {
        componentsByType[type] = component;
      }
    }
  });

  const streetNumber = getLongName(componentsByType.street_number);
  const route = getLongName(componentsByType.route);
  const addressLine1 = [streetNumber, route].filter(Boolean).join(' ');
  const city = getLongName(componentsByType.locality) || getLongName(componentsByType.sublocality_level_1);
  const state = getShortName(componentsByType.administrative_area_level_1);
  const zipCode = getLongName(componentsByType.postal_code);
  const country = getLongName(componentsByType.country);

  return {
    addressLine1,
    city,
    state,
    zipCode,
    country,
  };
}
